import React, { ReactNode } from 'react'
import { DragOutlined } from '@ant-design/icons'
import { CustomReportSection } from '../../../../../redux/context/customReports/typesSection'
import { StyledLayoutItem, StyledDragHandle } from './StyledComponents'

interface LayoutItemProps {
  section: CustomReportSection
  content: ReactNode
  children?: ReactNode
  showDragHandle?: boolean
}

type Ref = any

const LayoutItem = React.forwardRef<Ref, LayoutItemProps>(
  ({ section, children, content, showDragHandle, ...restProps }, ref) => {
    return (
      <StyledLayoutItem ref={ref} key={section.id} data-cy={`section-${section.id}`} {...restProps}>
        {showDragHandle && (
          <StyledDragHandle className="layout-drag-handle">
            <DragOutlined />
          </StyledDragHandle>
        )}
        {content}
        {children}
      </StyledLayoutItem>
    )
  }
)

export default LayoutItem
